export default __webpack_public_path__ + "static/media/sponsor.4187292a.svg";